
import LayoutContent from '../../components/layouts/content2';
import React, {useState} from 'react';

import {useTranslation} from 'react-i18next';

import SpecialsScreen from './specials';

import CategoriesScreen from './categories';

import Cocktails from './cocktails';
import EventsScreen from './events';

function Index({setShowHappy}) { 

    const {i18n} = useTranslation();
    const [currentImage, setCurrentImage] = useState(require('./assets/event1.png'));
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);

    const eventImages = [
        require('./assets/event1.png'),
        require('./assets/event2.png'),
        require('./assets/event3.png'),
        require('./assets/event4.png'),
        require('./assets/event5.png'),
    ];

    const nextImage = () => {
        const currentIndex = eventImages.indexOf(currentImage);
        const nextIndex = (currentIndex + 1) % eventImages.length;
        setCurrentImage(eventImages[nextIndex]);
    };

    const prevImage = () => {
        const currentIndex = eventImages.indexOf(currentImage);
        const prevIndex = (currentIndex - 1 + eventImages.length) % eventImages.length;
        setCurrentImage(eventImages[prevIndex]);
    };

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    
                    <div style={{display: 'flex', justifyContent: 'center', marginBottom: 10, marginTop: -50}}>
                        <img
                            src={require('./assets/logo.png')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 340, height: 100, objectFit: 'contain', pointerEvents: 'none'}}
                        />
                    </div>

                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: 20,
                        padding: '20px 30px',
                        width: 600,
                        boxSizing: 'border-box',
                        textAlign: 'center',
                        border: '2px solid #66C3A9',
                        marginBottom: 20
                    }}>
                        <h2 style={{
                            color: '#FF2D8D',
                            fontSize: 32,
                            margin: '0 0 15px 0',
                            fontFamily: 'Abril',
                        }}>
                            HOST YOUR NEXT EVENT IN STYLE!
                        </h2>
                        <p style={{
                            color: '#333',
                            fontSize: 18,
                            lineHeight: '1.4',
                            margin: 0,
                            fontWeight: '600',
                            fontFamily: 'Noto Sans',
                        }}>
                            Our private event space seats up to 75 guests and includes its own bar! Perfect for Birthdays, weddings, reunions, or corporate gatherings. Take a look at our special place for your special occasions.
                        </p>
                    </div>

                    <div style={{width: '100%', marginBottom: 2, position: 'relative'}}>
                        <img
                            src={currentImage}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '100%',
                                height: 350,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />
                    </div>

                    <div style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 5,
                        position: 'relative',
                        paddingBottom: 60
                    }}>
                        <img 
                            src={require('./assets/right.png')} 
                            onClick={prevImage}
                            style={{width: 40, height: 40, cursor: 'pointer', flexShrink: 0}} 
                        />
                        
                        <div style={{
                            display: 'flex',
                            gap: 12,
                            overflowX: 'auto',
                            padding: '10px 5px',
                            width: '100%',
                            scrollBehavior: 'smooth'
                        }}>
                            {eventImages.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    onClick={() => setCurrentImage(img)}
                                    style={{
                                        width: 170,
                                        height: 110,
                                        objectFit: 'cover',
                                        borderRadius: 12,
                                        cursor: 'pointer',
                                        flexShrink: 0,
                                        border: currentImage === img ? '3px solid #FF2D8D' : '2px solid white',
                                        transition: 'all 0.3s ease'
                                    }}
                                />
                            ))}
                        </div>

                        <img 
                            src={require('./assets/left.png')} 
                            onClick={nextImage}
                            style={{width: 40, height: 40, cursor: 'pointer', flexShrink: 0}} 
                        />
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
            </LayoutContent>
        </div>
    );
}
export default Index;